import m from 'mithril';
import SessionController from '../../shared/session';
import Sidebar from './sidebar';
import Loading from '../../shared/loading';
import i18n from "../../shared/i18n/i18n";
import Toasts from "../../shared/toasts";
import RouterService from '../../shared/services/router.service';
import ModalManager from "../../shared/modal";
import Modal_Consent_Form from "../../shared/components/modal_consent_form";
import ArnBarWidget from "../../shared/tools/arn_bar_widget";

let loading = false;

function auth() {
    loading = true;
    SessionController.checkSession();

    if (!SessionController.session || !SessionController.session.identity || !SessionController.session.identity.rights.length > 0) {
        SessionController.getSession()
            .then(function () {
                if (!SessionController.session.identity) {
                    RouterService.navigateToAccountLogin();
                }
                else if (!SessionController.session.identity.rights.length > 0) {
                    RouterService.navigateToNoAccount();
                }
            })
            .catch(function () {
                console.log("TODO: Account/layout.js auth Get Session Catch");
                RouterService.navigateToAccountLogin();
            })
            .finally(function () {
                loading = false;
                m.redraw();
            });
    } else {
        loading = false;
    }
}

function openConsent() {
    if (SessionController?.session?.identity?.consentRequired) {
        ModalManager.open(i18n.t("terms_and_privacy"), ['no-close', 'modal-mid'], Modal_Consent_Form);
    }
}

const AccountLayout = {
    oninit: function (vnode) {
        if (m.route.param("sso-auth"))
            SessionController.verifySso(m.route.param("sso-auth"))
                .catch(function (error) {
                    Toasts.add("error", i18n.t("login_failed"), error);
                    auth();
                });
        else
            auth();

        let theme = localStorage.getItem("theme");
        if (!theme)
            theme = 'light';
        // todo this has no effect
        document.documentElement.setAttribute("theme", theme);
        localStorage.setItem("theme", theme);
        openConsent();
    },
    view: function (vnode) {
        return [m("main", [
                !loading ? [
                    m(Sidebar),
                    m("#content", vnode.children),
                ] : m(Loading),
            m(ArnBarWidget, { userId: SessionController?.session?.identity?.id })
            ]),
            m("#toaster")
        ];
    }
};

export default AccountLayout;
